



































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import qs from "@/components/queSheng.vue";

@Component({
  components: { qs },
})
export default class Home extends Vue {
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  public todayOpenList;
  public percent = 0;
  public returnWidth(item) {
    let widths = 0;
    this.todayOpenList.forEach((items) => {
      if (items.shows) {
        widths = items.widths;
      }
    });
    if (widths == 78.5) {
      widths = 100;
    }
    return widths;
  }
}
